import React, { useState, useEffect } from 'react';
import Link from 'react-router-dom/Link';
import ReactSidebar from "react-sidebar";
import './Sidebar.scss';

const Sidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll());
    return () => {
      window.removeEventListener('scroll', handleScroll());
    };
  }, []);

  const handleScroll = () => {
    let scrollpos = window.scrollY;
    window.addEventListener('scroll', function () {
      scrollpos = window.scrollY;
      if (scrollpos > 40) {
        document.body.classList.add('scrolled');
      } else {
        document.body.classList.remove('scrolled');
      }
    });
  };

  const manageOpenSidebar = () => {
    setSidebarOpen(true);
    document.body.classList.add('no-scrolled');
  }

  const manageCloseSidebar = () => {
    setSidebarOpen(false);
    document.body.classList.remove('no-scrolled');
  }

  return (
    <ReactSidebar
      sidebar={
        <React.Fragment>
          <span onClick={manageCloseSidebar} className='close'></span>
          <ul className='sidebar-content'>
            <li onClick={manageCloseSidebar}><Link to='/'>Home</Link></li>
            <ul className='has-childs'>
              Templates
              <li onClick={manageCloseSidebar}><Link to='/brewery'>Brewery</Link></li>
              <li onClick={manageCloseSidebar}><Link to='/oyashima'>Oyashima</Link></li>
            </ul>
            <li onClick={manageCloseSidebar}><Link to='/preferencias'>Preferencias</Link></li>
          </ul>
        </React.Fragment>
      }
      sidebarId={'sidebar'}
      touch={false}
      open={sidebarOpen}
      pullRight={true}
      onSetOpen={manageCloseSidebar}
      styles={{ sidebar: { background: "white" } }}
    >
      <div className='toggle-sidebar-wrapper'>
        <span id='logo'>
          <Link to='/'><i className='logo'/></Link>
        </span>
        <span id='toggle-sidebar' onClick={manageOpenSidebar} />
      </div>
    </ReactSidebar >
  )
}

export default Sidebar;